<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{header}}</h5>
     <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>
<div class="modal-body" >
    {{content}}
 </div>
 <div class="modal-footer">
    <button (click)="onNoButtonClick()" type="button" class="btn btn-primary" data-dismiss="modal">No</button>
    <button (click)="modal.close(true)" type="button" class="btn btn-secondary">Yes</button>
</div>